import {
  Option,
  SelectBox,
  SelectBoxProps,
  styled,
} from "@monolith-forensics/monolith-ui";
import {
  PreservationMethod,
  PRESERVATION_METHODS,
} from "../preservations.constants";

export type PreservationMethodSelectBoxProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

// Tooltip content component
const TooltipContent = styled(
  ({ className, data }: { className?: string; data: PreservationMethod }) => {
    return (
      <div className={className}>
        <div className="detail-title">Preservation Method</div>
        <div className="detail-item">
          <div className="detail-label">Name: </div>
          <div className="detail-value">{data.name || "None"}</div>
        </div>
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  max-width: 300px;

  .detail-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 8px;
  }

  .detail-item {
    display: flex;
    gap: 2px;
  }

  .detail-label {
    font-weight: bold;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 12px;
  }

  .detail-value {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 12px;
  }
`;

export const PreservationMethodSelectBox: React.FC<PreservationMethodSelectBoxProps> =
  (props) => {
    const records: PreservationMethod[] = PRESERVATION_METHODS;

    // Combine number and name in label for client-side search by either
    const options: Option[] = records.map((method) => {
      return {
        label: method.name,
        value: method.id,
        data: method,
      };
    });

    return (
      <SelectBox
        placeholder="Select or search for a preservation method..."
        label="Method"
        description="The method used to preserve the evidence"
        OptionTooltip={TooltipContent}
        openOnFocus={false}
        {...props}
        data={options}
        searchable={true}
      />
    );
  };
